import { RootState } from 'lib/core/data/reducer'

export const getFetching = (state: RootState) => {
  return state.customer.cartId.isFetching
}

export const getSuccess = (state: RootState) => {
  return state.customer.cartId.isSuccess
}

export const getFailure = (state: RootState) => {
  return state.customer.cartId.isFailure
}

export const getCartId = (state: RootState) => {
  return state.customer.cartId.payload
}
